import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import TermsConditions from './TermsConditions';
import PrivacyPolicy from './PrivacyPolicy';
import CookiePolicy from './CookiePolicy';

export const LegalModal = ({ isOpen, onClose, page }) => {
  const { t } = useTranslation();

  const getPageComponent = () => {
    switch (page) {
      case 'terms':
        return <TermsConditions />;
      case 'privacy':
        return <PrivacyPolicy />;
      case 'cookies':
        return <CookiePolicy />;
      default:
        return null;
    }
  };

  const getPageTitle = () => {
    switch (page) {
      case 'terms':
        return t('legal.terms_title');
      case 'privacy':
        return t('legal.privacy_title');
      case 'cookies':
        return t('legal.cookies_title');
      default:
        return '';
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 overflow-y-auto"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {/* Background Overlay */}
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
          
          {/* Modal Content */}
          <div className="relative min-h-screen">
            <motion.div
              className="relative w-full max-w-full"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              {/* Close Button */}
              <motion.button
                onClick={onClose}
                className="fixed top-6 right-6 z-50 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full shadow-xl flex items-center justify-center hover:bg-white transition-all duration-300 group"
                whileHover={{ scale: 1.1, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
              >
                <X className="w-6 h-6 text-slate-600 group-hover:text-slate-800 transition-colors" />
              </motion.button>

              {/* Back Button */}
              <motion.button
                onClick={onClose}
                className="fixed top-6 left-6 z-50 flex items-center space-x-2 px-4 py-2 bg-white/90 backdrop-blur-sm rounded-full shadow-xl hover:bg-white transition-all duration-300 group"
                whileHover={{ scale: 1.05, x: -5 }}
                whileTap={{ scale: 0.95 }}
              >
                <ArrowLeft className="w-5 h-5 text-slate-600 group-hover:text-slate-800 transition-colors" />
                <span className="text-sm font-medium text-slate-600 group-hover:text-slate-800 transition-colors">
                  Retour
                </span>
              </motion.button>

              {/* Page Content */}
              <div className="pt-20">
                {getPageComponent()}
              </div>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LegalModal;